export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="font-display text-2xl text-slate-50 sm:text-3xl" data-testid="page-title">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-slate-400">{subtitle}</p>}
    </div>
    {children}
  </div>
);

export const KpiCard = ({ label, value, testId, highlight }) => (
  <div className="rounded-md border border-white/[0.06] bg-[#141C2E] p-5" data-testid={testId}>
    <p className="text-xs uppercase tracking-wider text-slate-500">{label}</p>
    <p className="mt-2 font-display text-3xl" style={highlight ? { color: "var(--brand)" } : { color: "#F8F9FA" }}>{value}</p>
  </div>
);

export const Panel = ({ title, children, action, testId }) => (
  <section className="rounded-md border border-white/[0.06] bg-[#0F1626] p-5" data-testid={testId}>
    <div className="mb-4 flex items-center justify-between gap-3">
      <h3 className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-400">{title}</h3>
      {action}
    </div>
    {children}
  </section>
);

export const Info = ({ label, value, mono, testId }) => (
  <div>
    <p className="text-[11px] uppercase tracking-wider text-slate-500">{label}</p>
    <p className={`mt-0.5 text-sm text-slate-100 ${mono ? "font-mono-x" : ""}`} data-testid={testId}>{value ?? "—"}</p>
  </div>
);
